/**
 * 打印模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取打印客户端信息
export const queryPrintClient = () => {
    return req.get('/cloudprint/queryPrintClient');
}

// 打印订单-云打印
export const printOrder = (params) => {
    return req.post('/cloudprint/printOrder', params);
}

/**
 * 
 * 新增打印机接口-wuhao
 */
// 查询打印类型
export const getPrintTypeApi = (params) => {
        return req.get('/print/device/getPrintType', params);
    }
    // 查询默认打印机
export const getPrintDefaultApi = (params) => {
        return req.get('/print/device/getPrintDefault', params);
    }
    // 编辑医馆和个人默认打印机
export const editPrintDefaultApi = (params) => {
        return req.post('/print/device/editPrintDefault', params);
    }
    // 查询打印机列表
export const getPrintClientListApi = (params) => {
    return req.get('/cloudprint/getPrintClientList', params);
}

// 批量打印-云打印
export const batchPrint = (params) => {
    return req.post('/cloudprint/batchPrint', params);
}

// 批量打印-获取打印进度
export const consumeMessage = (params) => {
    return req.get('/task/consumeMessage', params);
}

// 查询打印记录
export const queryPrintRecord = (params) => {
    return req.post('/cloudprint/queryPrintRecord', params);
}

//检查配置的设备是否在线,同时检查有没有配置
export const checkDevice = (params) => {
    return req.get('/print/device/checkDevice', params);
}

//获取打印内容
export const getPrintContent = (params) => {
    return req.post('/cloudprint/printLocal', params);
}
//本地打印
export const printLocal = (params) => {
    return req.printPost('/print', params);
}
